<script>
import Intro from './home/Intro.vue';

export default {
  components: {
    Intro,
  },
};
</script>

<template>
    <div>
      <intro light />
      <section id="legacy-content">
        <b-container class="ombre">
          <h2 class="title">{{ $t('hos.redirection.title') }}</h2>
          <p class="title-desc" v-html="$t('hos.redirection.description')"></p>
          <div v-html="$t('hos.redirection.action_description')"></div>

          <ul class="list-group">
            <li class="list-group-item">
              <a href="https://framadate.org/polls/new?type=date&flow=on" class="d-flex">
                <i class="fas fa-2x fa-calendar-check fc-g7 pr-3 pt-1"></i>
                <span>
            <strong v-html="$t('hos.intro.btn-create-date')"></strong>
            <br />
            <small
                class="text-secondary"
                v-html="$t('hos.intro.help-create-date')"
            ></small>
          </span>
              </a>
            </li>

            <li class="list-group-item">
              <a href="https://framadate.org/polls/new?type=classic&flow=on" class="d-flex">
                <i class="fas fa-2x fa-square-poll-vertical fc-g7 pr-3 pt-1"></i>
                <span>
            <strong v-html="$t('hos.intro.btn-create-classic')"></strong>
            <br />
            <small
                class="text-secondary"
                v-html="$t('hos.intro.help-create-classic')"
            ></small>
          </span>
              </a>
            </li>
          </ul>
        </b-container>
      </section>
    </div>
</template>
<style lang="scss">
#legacy {
  #app {
    background-color: var(--f-body-bg);
  }

  > .container {
    background-color: var(--f-body-bg);
  }

  #legacy-content > .container {
    border-radius: 8px;
  }

  .title {
    font-size: 48px;
  }

  .title-desc {
    font-size: 26px;
  }

  .buttons {
    margin: 4rem 0 5.5rem;
    padding: 0;
    list-style: none;
    max-width: 500px;

    @media (max-width: 768px) {
      margin: 3rem 0 1.5rem;
    }

    @media (max-width: 1200px) {
      max-width: 100%;
    }

    @media (max-width: 768px) {
      max-width: 45%;
    }

    @media (max-width: 576px) {
      max-width: 66%;
    }

    > li {
      display: flex;
      align-items: center;

      > div > .btn,
      > .btn {
        display:flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 0.5rem 1rem;
        white-space: normal;

        @media (max-width: 992px) {
          font-size: 1rem;
        }

        @media (max-width: 576px) {
          font-size: .875rem;
        }
      }

      .btn {
        font-weight: bold;
      }
    }

    .btn-outline-warning {
      background: #fff;
      border-color: #fff;
      font-weight: bold;

      &:hover, &:focus, &:active {
        background: var(--f-o7);
        border-color: var(--f-o7);
        color: #fff;
      }
    }

    .dropdown {
      width: 100%;
    }

    .dropdown-item {
      padding: 0;

      &:active, &:focus, &:hover {
        color: var(--f-g8);
        background: var(--f-g3);
      }

      > .d-flex {
        padding: .5rem 1rem;
        white-space: normal;
      }
    }

    .dropdown-menu {
      background-color: var(--f-g1);

      li {
        width: 420px;
        @media (max-width: 460px) {
          width: 320px;
        }
      }
    }
  }
}
</style>
